const LoginScreen = () => import('../screens/Auth/Login/LoginScreen.vue');
const Logout = () => import('../screens/Auth/Logout/LogoutScreen.vue');
const ResetPasswordScreen = () => import('../screens/Auth/ResetPassword/ResetPasswordScreen.vue');
const OtpScreen = () => import('../screens/Auth/OtpVerification/OtpVerificationScreen.vue');
const ForgetPasswordScreen = () =>
  import('../screens/Auth/ForgetPassword/ForgetPasswordScreen.vue');
const MobileRegistration = () =>
  import('../screens/Auth/MobileRegistration/MobileRegistrationScreen.vue');

export default [
  {
    component: LoginScreen,
    meta: {
      mixpanelPageName: 'Log in',
      pageTitle: 'Login',
      transition: 'slide-down',
    },
    name: 'login',
    path: '/login',
  },
  {
    component: Logout,
    meta: {
      mixpanelPageName: 'Log out',
      pageTitle: 'logout',
      transition: 'slide-down',
    },
    name: 'logout',
    path: '/logout',
  },
  {
    component: ForgetPasswordScreen,
    meta: {
      mixpanelPageName: 'Forgot Password',
      pageTitle: 'Forgot Password',
      transition: 'slide-down',
    },
    name: 'forget-password',
    path: '/password/forget',
  },
  {
    component: ResetPasswordScreen,
    meta: {
      mixpanelPageName: 'Reset Password',
      pageTitle: 'Reset password',
      transition: 'slide-down',
    },
    name: 'reset-password',
    path: '/password/reset/:token',
    props: true,
  },
  {
    component: OtpScreen,
    meta: {
      mixpanelPageName: 'OTP',
      pageTitle: 'OTP Verification',
      transition: 'slide-down',
    },
    name: 'otpVerification',
    path: '/otp/:token',
    props: true,
  },
  {
    component: MobileRegistration,
    meta: {
      mixpanelPageName: 'Mobile Registration',
      pageTitle: 'Mobile registerations',
      requireAuth: true,
      transition: 'slide-down',
    },
    name: 'mobile-registration',
    path: '/mobile-registration',
  },
];
